import {DataStatus, Tabs} from 'platform/components';

import {RefObject} from 'react';

import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetServiceOrderIntegrationsQuery} from '@dms/api/workshop';
import i18n from '@dms/i18n';

import {TestIdProps, suffixTestId} from 'shared/web';

import {EditMaterialItemAdditionalInformation} from './components/EditMaterialItemAdditionalInformation';
import {EditMaterialItemForm} from './components/EditMaterialItemForm';

const BASIC_INFORMATION = 'BASIC_INFORMATION';
const ADDITIONAL_INFORMATION = 'ADDITIONAL_INFORMATION';

interface EditMaterialItemProps extends TestIdProps {
  itemId: string;
  serviceCaseId: string;
  serviceOrderId: string;
  serviceJobId: string;
  onClose: VoidFunction;
  serviceOrderIssueNoteId?: string;
  isSavedByRowControlRef?: RefObject<boolean>;
  formRef?: RefObject<{
    submit: () => Promise<boolean>;
    isDirty: boolean;
  } | null>;
}

export const EditMaterialItem = (props: EditMaterialItemProps) => {
  const {
    data: serviceOrderIntegrations,
    isLoading: isServiceOrderIntegrationsLoading,
    isError: isServiceOrderIntegrationsError,
  } = useGetServiceOrderIntegrationsQuery(
    {
      serviceCaseId: props.serviceCaseId,
      serviceOrderId: props.serviceOrderId,
    },
    {skip: isNilOrEmpty(props.serviceCaseId) || isNilOrEmpty(props.serviceOrderId)}
  );

  const isClaraIntegrationEnabled = serviceOrderIntegrations?.orderIntegration?.some(
    (integration) => integration?.integration?.code === 'DAIMLER_CLARA'
  );

  return (
    <DataStatus
      isLoading={isServiceOrderIntegrationsLoading}
      isError={isServiceOrderIntegrationsError}
    >
      <Tabs
        tabs={[
          {
            content: <EditMaterialItemForm {...props} />,
            title: i18n.t('general.labels.basicInformation'),
            id: BASIC_INFORMATION,
          },
          {
            content: (
              <EditMaterialItemAdditionalInformation
                orderId={props.serviceOrderId}
                serviceCaseId={props.serviceCaseId}
                serviceJobId={props.serviceJobId}
                serviceItemId={props.itemId}
                data-testid={suffixTestId('additional-information', props)}
              />
            ),
            title: i18n.t('general.labels.additionalInformation'),
            id: ADDITIONAL_INFORMATION,
            isDisabled: !isClaraIntegrationEnabled,
          },
        ]}
        variant="condensed"
      />
    </DataStatus>
  );
};
